import { createI18n } from "vue-i18n";
import { getBestLangForBrowser } from "./mixins/UtilsLang";

export function loadLocaleMessages() {
  const locales = require.context(
    "./locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

export const i18n = createI18n({
  legacy: true, // keeps Options API this.$t()/this.$i18n usage working as-is across the app
  locale: getBestLangForBrowser(), //navigator.languages returns browser settings [en-US,fr-FR..
  fallbackLocale: "fr-FR",
  messages: loadLocaleMessages(),
});
